import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AddBlog.css";
import { BACKEND_URL } from "../../../config";

function Blog() {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [viewData, setViewData] = useState(null);
  const [search, setSearch] = useState("");

  const fetchBlogs = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api.php?module=blog`);
      const result = await res.json();
      if (result.success) setBlogs(result.data);
      else setBlogs([]);
    } catch (err) { setBlogs([]); }
  };

  useEffect(() => { fetchBlogs(); }, []);

  const filteredBlogs = blogs.filter(
  (b) =>
    b.title?.toLowerCase().includes(search.toLowerCase()) ||
    b.author?.toLowerCase().includes(search.toLowerCase())
);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete blog?")) return;
    await fetch(`${BACKEND_URL}/api.php?module=blog`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    fetchBlogs();
  };

  useEffect(() => {
    if (viewData) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [viewData]);

  return (
    <div className="admin-page">
      {/* CHANGE: inline style hata kar "page-header-bar" class lagayi - mobile pe stack hoga */}
      <div className="page-header-bar">
        <h2>Blog List</h2>

        <div className="header-actions">
          <input
            type="text"
            className="page-search-input"
            placeholder="Search Title or Author..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <button
            className="admin-btn add"
            onClick={() => navigate("/admin/blog/add")}
          >
            + Add Blog
          </button>
        </div>
      </div>

      <div className="admin-table">
        <table>
          <thead>
            <tr><th>Title</th><th>Author</th><th>Image</th><th>Action</th></tr>
          </thead>
          <tbody>
            {filteredBlogs.map((b) => (
              <tr key={b.id}>
                <td>{b.title}</td>
                <td>{b.author}</td>
                <td>{b.image ? <img src={`${BACKEND_URL}/${b.image}`} width="60" alt="" /> : "-"}</td>
                <td className="action-btns">
                  <button className="admin-btn view" onClick={() => setViewData(b)}>View</button>
                  <button className="admin-btn edit" onClick={() => navigate(`/admin/blog/edit/${b.id}`)}>Edit</button>
                  <button className="admin-btn delete" onClick={() => handleDelete(b.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {viewData && (
        <div className="vm-overlay" onClick={() => setViewData(null)}>
          <div className="vm-box" onClick={(e) => e.stopPropagation()}>

            <div className="vm-header">
              <span className="vm-header-title">Blog Details</span>
              <button className="vm-close-btn" onClick={() => setViewData(null)}>✕</button>
            </div>

            <div className="vm-scroll">

              <div className="vm-top-row">
                {viewData.image && (
                  <div className="vm-img-box">
                    <img src={`${BACKEND_URL}/${viewData.image}`} alt="" />
                  </div>
                )}
                <div className="vm-top-info">
                  <p className="vm-product-name">{viewData.title}</p>
                  <p className="vm-product-sub">By {viewData.author}</p>
                </div>
              </div>

              <div className="vm-info-grid">
                <div className="vm-info-item"><span className="vm-label">Author</span><span className="vm-value">{viewData.author}</span></div>
                <div className="vm-info-item"><span className="vm-label">Date</span><span className="vm-value">{viewData.date}</span></div>
              </div>

              <div className="vm-section">
                <p className="vm-section-title">Keywords</p>
                <div className="vm-tags">
                  {viewData.keywords
                    ? viewData.keywords.split(",").map((k, i) => <span key={i} className="vm-tag">{k.trim()}</span>)
                    : "-"}
                </div>
              </div>

            </div>

            <div className="vm-footer">
              <button className="vm-footer-edit" onClick={() => { navigate(`/admin/blog/edit/${viewData.id}`); setViewData(null); }}>Edit</button>
              <button className="vm-footer-delete" onClick={() => { handleDelete(viewData.id); setViewData(null); }}>Delete</button>
              <button className="vm-footer-close" onClick={() => setViewData(null)}>Close</button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

export default Blog;
